










import Vue from 'vue';
import { mapGetters } from 'vuex';
import CabinetConfigurationMakeChangesLock from '@/components/configuration/CabinetConfigurationMakeChangesLock.vue';
import MStoreQuickActions from '@/components/shared/MStoreQuickActions.vue';
import { MStoreDashboardButtonModel, FontAwesomeIcons, StoreConstants, Configuration } from '@/types';

export default Vue.extend({
  computed: {
    ...mapGetters(StoreConstants.CabinetConfiguration.ModuleName, [StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationLockHeldByCurrentSession]),
    title(this: any) {
      return 'Document Type Quick Actions';
    },
    cabinetId(this: any) {
      return this.$route.params.cabinetId;
    },
    documentTypeId(this: any) {
      return this.$route.params.documentTypeId;
    },
    dashboardButtons(this: any) {
      return [
        {
          icon: FontAwesomeIcons.Folder,
          text: 'Document Type Configuration',
          routeName: 'editDocumentType',
          routeParams: {}
        },
        {
          icon: FontAwesomeIcons.Trash,
          text: 'Delete Document Type',
          routeName: 'deleteDocumentType',
          routeParams: {},
          isDisabled: !this.cabinetConfigurationLockHeldByCurrentSession
        },
        {
          icon: FontAwesomeIcons.Shield,
          text: 'Permissions',
          routeName: Configuration.Cabinet.DocumentTypeSecurityConfiguration.name,
          routeParams: { cabinetId: this.cabinetId, documentTypeId: this.documentTypeId }
        }
      ] as MStoreDashboardButtonModel[];
    }
  },
  created(this: any) {
    this.FONTAWESOME_ICONS = FontAwesomeIcons;
  },
  components: {
    MStoreQuickActions,
    CabinetConfigurationMakeChangesLock
  }
});
